import { api } from "./client";
import type { ApiResponse } from "./types";

export type ClaimEntityType =
  | "provider"
  | "institution"
  | "event_organizer_prospect";
export type ClaimStatus = "pending" | "approved" | "rejected" | "changes_requested" | "expired";

export interface EntityClaim {
  id: string;
  claimantUserId: string;
  entityType: ClaimEntityType;
  entityId: string;
  status: ClaimStatus;
  claimantNote: string | null;
  evidenceUrls: string[];
  reviewNote: string | null;
  memberMessage?: string | null;
  expiresAt?: string | null;
  createdAt: string;
  entityName?: string | null;
  claimant?: { id: string; name: string; email: string };
}

export function submitClaim(input: {
  entityType: ClaimEntityType;
  entityId: string;
  claimantNote?: string;
  evidenceUrls?: string[];
}) {
  return api.post<ApiResponse<EntityClaim>>("/claims", input);
}

export function myClaims() {
  return api.get<ApiResponse<{ claims: EntityClaim[] }>>("/claims/me");
}

// ─── Admin ─────────────────────────────────────────────────────────

export function listPendingClaims(params?: { page?: number; limit?: number }) {
  return api.get<{ success: true; data: { claims: EntityClaim[] }; meta?: unknown }>(
    "/admin/claims",
    params as Record<string, string | number | undefined>,
  );
}

export function approveClaim(id: string, reviewNote?: string) {
  return api.post<ApiResponse<{ status: string }>>(`/admin/claims/${id}/approve`, { reviewNote });
}

export function rejectClaim(id: string, reviewNote?: string) {
  return api.post<ApiResponse<{ status: string }>>(`/admin/claims/${id}/reject`, { reviewNote });
}
